export default __webpack_public_path__ + "static/media/homepage-banner.66523cf7.png";